import { useSyncExternalStore } from 'react';

export const DISPLAY_SCALE_KEY = 'cui-display-scale-v1';
export const DISPLAY_SCALE_MIN = 0.75;
export const DISPLAY_SCALE_MAX = 1.75;
const eventName = 'cui-display-scale-change';
const normalise = (n: number) => Math.round(Math.min(DISPLAY_SCALE_MAX, Math.max(DISPLAY_SCALE_MIN, n)) * 100) / 100;
function read(): number | null {
  try {
    const raw = localStorage.getItem(DISPLAY_SCALE_KEY);
    const n = raw === null ? NaN : Number(raw);
    return Number.isFinite(n) && n > 0 ? normalise(n) : null;
  } catch { return null; }
}
let value = read();
function subscribe(callback: () => void) {
  const onStorage = (event: StorageEvent) => {
    if (event.key === DISPLAY_SCALE_KEY || event.key === null) { value = read(); callback(); }
  };
  window.addEventListener(eventName, callback);
  window.addEventListener('storage', onStorage);
  return () => { window.removeEventListener(eventName, callback); window.removeEventListener('storage', onStorage); };
}
export function setDisplayScale(next: number) {
  if (!Number.isFinite(next)) return;
  value = normalise(next);
  try { localStorage.setItem(DISPLAY_SCALE_KEY, String(value)); } catch { /* Still usable when storage is unavailable. */ }
  window.dispatchEvent(new Event(eventName));
}
export function useDisplayScale(fallback = 1) {
  const stored = useSyncExternalStore(subscribe, () => value, () => null);
  return stored ?? normalise(Number.isFinite(fallback) ? fallback : 1);
}
